import { getIsDarkTheme } from 'owa-fabric-theme';
import { observer } from 'owa-mobx-react';
import React from 'react';
import { createDarkTheme, createLightTheme, FluentProvider } from '@fluentui/react-components';

import type { BrandVariants } from '@fluentui/react-components';

// Colors for Places Brand:
// https://www.figma.com/file/SicJs4UNaTg29YS8yqhqFv/Fluent-2-design-language?type=design&node-id=53519-2914&mode=design&t=cWfqSLJxGosLE2Y4-4
const placesBrandTheme: BrandVariants = {
    10: '#050107',
    20: '#1F0F2E',
    30: '#311555',
    40: '#3D1A77',
    50: '#47209C',
    60: '#4F28C1',
    70: '#5432E6',
    80: '#5B41FF',
    90: '#6C56FF',
    100: '#7B69FF',
    110: '#8A7BFF',
    120: '#988DFF',
    130: '#A79EFF',
    140: '#B5B0FF',
    150: '#C4C1FF',
    160: '#E4E2FF',
};

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createLightTheme called at module scope is not allowed. This may cause unwanted side effects. */
const placesLightTheme = createLightTheme(placesBrandTheme);
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createDarkTheme called at module scope is not allowed. This may cause unwanted side effects. */
const placesDarkTheme = createDarkTheme(placesBrandTheme);

export const PlacesFluentProvider: React.FunctionComponent<
    React.PropsWithChildren<{
        className?: string;
        style?: React.CSSProperties;
        isDarkTheme?: boolean;
    }>
> = observer(function PlacesFluentProvider({
    className,
    children,
    style,
    isDarkTheme = getIsDarkTheme(),
}: React.PropsWithChildren<{
    className?: string;
    style?: React.CSSProperties;
    isDarkTheme?: boolean;
}>) {
    const theme = isDarkTheme ? placesDarkTheme : placesLightTheme;
    return (
        <FluentProvider className={className} theme={theme} style={style}>
            {children}
        </FluentProvider>
    );
}, 'PlacesFluentProvider');
